module.exports = "/static/assets/4cfb617bd5ddb3963da6bdc2a814d06c.gif";